import { render, staticRenderFns } from "./MoreTrademark.vue?vue&type=template&id=2e682ed2&scoped=true"
import script from "./MoreTrademark.vue?vue&type=script&lang=js"
export * from "./MoreTrademark.vue?vue&type=script&lang=js"
import style0 from "./MoreTrademark.vue?vue&type=style&index=0&id=2e682ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e682ed2",
  null
  
)

export default component.exports